import React from "react";
import cx from "classnames";
import Button from "../../Forms/Button/Button";
import Icon from "../../Icon/Icon";
import LModal from "../LModal/LModal";
import { IconSetIds } from "../../Icon/IconMap";

type AcknowledgementModalProps = {
    hasSucceeded: boolean;
    isOpen: boolean;
    onClose: () => void;
    successContent?: React.ReactNode;
    errorContent?: React.ReactNode;
    iconId?: IconSetIds;
};

const AcknowledgementModal: React.FC<AcknowledgementModalProps> = (props) => {
    const { hasSucceeded, isOpen, onClose } = props;

    const successContent =
        props.successContent || "Thank you, we have received your request.";
    const errorContent =
        props.errorContent || "Oops, something went wrong.\nPlease try again later.";

    const iconId: IconSetIds = props.iconId || "DogThanks";

    return (
        <LModal Header={null} isOpen={isOpen} calcHeightMode="auto" width="narrow">
            {() => (
                <React.Fragment>
                    <Icon
                        id={hasSucceeded ? iconId : "OopsThanks"}
                        className={cx("gap-l", "layout-img-thanks")}
                    />
                    <div className={cx("gap-l", "text-font-size-ml")}>
                        {hasSucceeded ? successContent : errorContent}
                    </div>
                    <div>
                        <Button
                            component="button"
                            type="button"
                            onClick={onClose}
                            size="m"
                            variant="calltoaction">
                            Ok
                        </Button>
                    </div>
                </React.Fragment>
            )}
        </LModal>
    );
};

export default AcknowledgementModal;
